import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { Select, Spin, Divider } from 'antd'

import { withTranslation } from 'react-i18next'

const SelectSearchPaymentVoucher = ({
    defaultValue,
    loading,
    onChange,
    onSearch,
    paymentVouchers,
    value,
    i18n,
    ...restSelectProps
}) => {
    return (
        <Select
            allowClear
            defaultActiveFirstOption={false}
            defaultValue={_.map(defaultValue, 'id')}
            dropdownRender={(menu) => (
                <div>
                    {menu}

                    {loading &&
                    <>
                        <Divider style={{ margin: '4px 0' }} />

                        <div
                            style={{ textAlign: 'center' }}
                        >
                            <Spin size="small" />
                        </div>
                    </>
                    }
                </div>
            )}
            filterOption={false}
            loading={loading}
            notFoundContent={loading ? <Spin size="small" /> : null}
            onChange={onChange}
            onSearch={onSearch}
            placeholder={i18n.t('confirms:paymentVoucher.searchPaymentVoucher')}
            showArrow={false}
            showSearch
            style={restSelectProps.style || { width: '200px' }}
            // value={['1','2','3']}
            mode="multiple"
            {...restSelectProps}
        >
            {paymentVouchers.map((paymentVoucher, index) => {
                return (
                    <Select.Option
                        key={_.get(paymentVoucher, 'id', `index-${index}`)}
                        value={_.get(paymentVoucher, 'id', undefined)}
                    >
                        {_.get(paymentVoucher, 'external_id', '')}
                    </Select.Option>
                )
            })}
            {defaultValue.map((paymentVoucher, index) => {
                return (
                    <Select.Option
                        key={_.get(paymentVoucher, 'id', `index-${index}`)}
                        value={_.get(paymentVoucher, 'id', undefined)}
                    >
                        {_.get(paymentVoucher, 'external_id', '')}
                    </Select.Option>
                )
            })}
        </Select>
    )
}

SelectSearchPaymentVoucher.propTypes = {
    defaultValue: PropTypes.string,
    loading: PropTypes.bool,
    onChange: PropTypes.func,
    onSearch: PropTypes.func,
    paymentVoucher: PropTypes.array,
    value: PropTypes.string
}

SelectSearchPaymentVoucher.defaultProps = {
    defaultValue: undefined,
    loading: false,
    onChange: () => {},
    onSearch: () => {},
    paymentVoucher: [],
    value: undefined
}

export default withTranslation(['confirms'])(SelectSearchPaymentVoucher)
